import type { FC, ReactNode } from 'react'

import Head from 'next/head'

import { siteConfig } from '@/constants/site'

/**
 * Structured data for the business, rendered once on the home page.
 * Only facts the business publishes itself belong here.
 */
const schema = {
    '@context': 'https://schema.org',
    '@type': 'HousePainter',
    name: siteConfig.name,
    url: siteConfig.url,
    description: siteConfig.description,
    image: `${siteConfig.url}/images/ng/hero-house-new-bedford.webp`,
    logo: `${siteConfig.url}/images/ng/logo-wordmark.png`,
    telephone: '+1-774-301-1382',
    email: siteConfig.email,
    foundingDate: '2000',
    address: {
        '@type': 'PostalAddress',
        addressLocality: 'New Bedford',
        addressRegion: 'MA',
        addressCountry: 'US'
    },
    areaServed: [
        { '@type': 'City', name: 'New Bedford, MA' },
        { '@type': 'City', name: 'Dartmouth, MA' },
        { '@type': 'City', name: 'Fairhaven, MA' },
        { '@type': 'City', name: 'Acushnet, MA' },
        { '@type': 'City', name: 'Westport, MA' },
        { '@type': 'City', name: 'Fall River, MA' },
        { '@type': 'State', name: 'Massachusetts' }
    ],
    openingHoursSpecification: [
        {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            opens: '07:00',
            closes: '21:00'
        }
    ]
}

export const BusinessSchema: FC = (): ReactNode => {
    return (
        <Head>
            <script
                key='business-schema'
                type='application/ld+json'
                dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
            />
        </Head>
    )
}
